import request from '../../utils/request';
import {ExchangeRate} from "@/types";

/** Fetch available batch identifiers (YYYYMM). */
export function fetchBatches(): Promise<string[]> {
  return request.get('/api/hospital/data-batches').then((res) => res.data);
}


/** Fetch all available exchange rates. */
export function fetchExchangeRates(): Promise<ExchangeRate[]> {
  return request.get('/api/analysis/exchange-rate').then((res) => {
    const data:ExchangeRate[] = res.data;

    const curs = new Set(data.map(batch => batch.target_currency));
    // 本国货币对本国货币补上
    for (const cur of curs) {
      data.push({
        base_currency: cur,
        exchange_rate: 1,
        target_currency: cur,
        year: 0
      })
    }
    return data

  });
}
